import { RecaptchaVerifier } from 'firebase/auth';
import {
  MFA_EMULATOR_RECAPTCHA_TOKEN,
  MFA_RECAPTCHA_CONTAINER_ID,
  MFA_RECAPTCHA_REQUEST,
  MFA_RECAPTCHA_RESET,
  MFA_RECAPTCHA_RESPONSE,
} from './mfa-recaptcha-constants';
import { getSwAlignedAuth, isExtensionAuthEmulatorEnabled } from './sw-aligned-firebase';

let bridgeRegistered = false;
let recaptchaVerifier: RecaptchaVerifier | null = null;

function getChromeRuntime():
  | {
      onMessage: {
        addListener: (
          cb: (
            message: { type?: string; requestId?: string },
            sender: unknown,
            sendResponse: (response: unknown) => void
          ) => boolean | void
        ) => void;
      };
      sendMessage: (message: unknown) => void;
    }
  | undefined {
  if (typeof window === 'undefined') return undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).chrome?.runtime;
}

function getRecaptchaVerifier(): RecaptchaVerifier {
  if (!recaptchaVerifier) {
    recaptchaVerifier = new RecaptchaVerifier(getSwAlignedAuth(), MFA_RECAPTCHA_CONTAINER_ID, {
      size: 'invisible',
    });
  }
  return recaptchaVerifier;
}

export function resetMfaRecaptchaVerifier(): void {
  if (recaptchaVerifier) {
    try {
      recaptchaVerifier.clear();
    } catch {
      // ignore
    }
    recaptchaVerifier = null;
  }
}

/**
 * Handle MFA reCAPTCHA requests from the extension service worker (embedded SPA + login MFA).
 */
export function initMfaRecaptchaBridge(): void {
  const runtime = getChromeRuntime();
  if (bridgeRegistered || !runtime?.onMessage) {
    return;
  }
  bridgeRegistered = true;

  runtime.onMessage.addListener((message, _sender, sendResponse) => {
    if (message?.type === MFA_RECAPTCHA_RESET) {
      resetMfaRecaptchaVerifier();
      return false;
    }

    if (message?.type !== MFA_RECAPTCHA_REQUEST || typeof message.requestId !== 'string') {
      return false;
    }

    const requestId = message.requestId;

    void (async () => {
      try {
        const token = isExtensionAuthEmulatorEnabled()
          ? MFA_EMULATOR_RECAPTCHA_TOKEN
          : await getRecaptchaVerifier().verify();
        const payload = { type: MFA_RECAPTCHA_RESPONSE, requestId, token };
        sendResponse(payload);
        runtime.sendMessage(payload);
      } catch (error: unknown) {
        const errMsg = error instanceof Error ? error.message : 'reCAPTCHA failed';
        const payload = { type: MFA_RECAPTCHA_RESPONSE, requestId, error: errMsg };
        sendResponse(payload);
        runtime.sendMessage(payload);
      }
    })();

    return true;
  });
}
